import { render, staticRenderFns } from "./Datenschutzrichtlinie.vue?vue&type=template&id=eba4a14a&scoped=true"
import script from "./Datenschutzrichtlinie.vue?vue&type=script&lang=js"
export * from "./Datenschutzrichtlinie.vue?vue&type=script&lang=js"
import style0 from "./Datenschutzrichtlinie.vue?vue&type=style&index=0&id=eba4a14a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4a14a",
  null
  
)

export default component.exports